export const plotEpisodes = [
  {
    id: 1,
    episode: 1,
    title: '雨夜归来的旧客',
    summary: '一场秋雨把离家七年的林小满带回顾家老宅，也带回了一封没有署名的信。',
    date: '2026-08-12',
    duration: '45分钟',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20stylized%20illustration%20of%20a%20rainy%20old%20courtyard%20at%20night%20with%20warm%20lantern%20light%20and%20deep%20crimson%20tones%2C%20moody%20elegant%20film%20poster%20art%2C%20wet%20stone%20path%2C%20no%20text%2C%20soft%20atmospheric%20fog%2C%20restrained%20editorial%20palette%20of%20ivory%20and%20muted%20red&width=800&height=500&seq=plot-ep01&orientation=landscape',
    paragraphs: [
      '深秋的雨落在顾家老宅的青石台阶上。七年没有回过家的林小满拖着一只旧行李箱站在门外，她并没有提前通知任何人，只在门缝里看见客厅那盏始终没有换过的灯。',
      '顾长川开门的时候，手里还握着半杯凉透的茶。他叫了她一声名字，随即沉默。两个人之间隔着七年的空白，也隔着一封从海外寄回、至今无人承认写过的信。',
      '本集以老宅为轴，交代了顾家兄妹、林小满与姐姐苏婉之间微妙的关系。片尾，林小满在阁楼找到一张被撕去一半的合影，照片背面只有一句话：别让这个家再散一次。',
    ],
  },
  {
    id: 2,
    episode: 2,
    title: '没有名字的家宴',
    summary: '顾老爷子第一次为小满下厨，桌上却多摆了一副没有人坐的碗筷。',
    date: '2026-08-19',
    duration: '44分钟',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20still%20life%20of%20an%20elegant%20Chinese%20family%20dinner%20table%20at%20dusk%20with%20ivory%20porcelain%2C%20amber%20lamp%20glow%20and%20deep%20red%20accents%2C%20moody%20editorial%20photography%20style%2C%20empty%20chair%2C%20no%20text%2C%20quiet%20dramatic%20atmosphere&width=800&height=500&seq=plot-ep02&orientation=landscape',
    paragraphs: [
      '为了给小满接风，顾老爷子破例亲自下厨。饭桌上摆满了旧日的菜色，主位旁却多了一副干净的碗筷。没有人解释那是留给谁的。',
      '苏婉在席间谈起丈夫最近的忙，语气平稳得像在念一段台词。林小满安静地听着，只在老爷子夹菜到她碗里时，眼眶忽然红了。',
      '这一集没有大的冲突，全部张力都藏在吃饭的节奏里。结尾顾长川独自收拾桌子，把那副没人用过的碗筷收进柜子，动作停了三秒。',
    ],
  },
  {
    id: 3,
    episode: 3,
    title: '被撕掉的一半合影',
    summary: '照片的另一半出现在苏婉的抽屉里，两个女人第一次正面相对。',
    date: '2026-08-26',
    duration: '46分钟',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20scene%20of%20two%20women%20standing%20in%20a%20sunlit%20corridor%2C%20long%20shadows%20across%20wooden%20floor%2C%20deep%20red%20curtain%20edge%2C%20restrained%20ivory%20and%20wine%20color%20palette%2C%20elegant%20film%20poster%20mood%2C%20no%20text%2C%20emotional%20distance%20composition&width=800&height=500&seq=plot-ep03&orientation=landscape',
    paragraphs: [
      '林小满想知道照片背后那句警告是谁写的。她翻遍了阁楼，最后在苏婉梳妆台最下层的抽屉里看见了另一半。',
      '苏婉没有抢，也没有解释，只是说了一句：有些东西，拼回去也不一定是原来的样子。两个人隔着半开的门站了很久。',
      '本集揭开了七年前那场家庭变故的一角：一次没有对外说明的意外，让顾家从此改变了所有人的位置。',
    ],
  },
  {
    id: 4,
    episode: 4,
    title: '厨房里的旧时光',
    summary: '一道失传的家常菜，让顾长川第一次谈起母亲离开的那年。',
    date: '2026-09-02',
    duration: '45分钟',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20illustration%20of%20a%20rustic%20Chinese%20kitchen%20with%20steam%20rising%20from%20a%20pot%2C%20warm%20amber%20light%2C%20deep%20crimson%20tiled%20wall%2C%20quiet%20nostalgic%20film%20still%2C%20ivory%20highlights%2C%20no%20text%2C%20soft%20shadow%20and%20texture%20detail&width=800&height=500&seq=plot-ep04&orientation=landscape',
    paragraphs: [
      '小满试着复刻母亲留下的一道菜，火候总是差一点。顾长川站在门口看了很久，终于走进来接手锅铲。',
      '做菜的过程里，他第一次主动谈起母亲离开的那年冬天。他说那时候自己只有十六岁，以为只要把家守住，所有人都会回来。',
      '这一集把厨房拍成了一间储藏记忆的房间。菜端上桌时，顾老爷子尝了一口，什么也没说，只是多添了一碗饭。',
    ],
  },
  {
    id: 5,
    episode: 5,
    title: '宴会上的陌生人',
    summary: '顾家为老宅修缮举办宴会，一位自称旧友的客人带来不利的消息。',
    date: '2026-09-09',
    duration: '47分钟',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20cinematic%20banquet%20hall%20scene%20with%20crystal%20chandeliers%2C%20deep%20red%20drapery%20and%20warm%20golden%20light%2C%20blurred%20guests%20in%20formal%20wear%2C%20moody%20editorial%20film%20still%2C%20ivory%20and%20burgundy%20palette%2C%20no%20text%2C%20sophisticated%20suspenseful%20atmosphere&width=800&height=500&seq=plot-ep05&orientation=landscape',
    paragraphs: [
      '老宅修缮完成，顾家办了一场小型宴会。周衍作为合作方出席，他身旁那位自称旧友的客人却在敬酒时提起了一桩旧债。',
      '苏婉的脸色第一次在众人面前失守。顾长川把小满拉到侧厅，叮嘱她今晚不要单独见客。',
      '宴会散场后，花园里的石桌上留着一只不属于任何宾客的酒杯。镜头停在那只杯子上，雨又落了下来。',
    ],
  },
  {
    id: 6,
    episode: 6,
    title: '雨停之前',
    summary: '小满与长川在停雨的间隙说出真心话，又被一通电话打断。',
    date: '2026-09-16',
    duration: '45分钟',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20scene%20of%20a%20man%20and%20woman%20under%20a%20stone%20archway%20during%20rain%2C%20warm%20amber%20lamp%20behind%20them%2C%20deep%20crimson%20umbrella%2C%20elegant%20restrained%20film%20poster%20art%2C%20ivory%20mist%2C%20no%20text%2C%20intimate%20tense%20atmosphere&width=800&height=500&seq=plot-ep06&orientation=landscape',
    paragraphs: [
      '雨下了一整夜。小满在廊下收衣服，顾长川撑着伞走过来，两个人第一次把话说到了最深处。',
      '他说这些年自己一直不敢问她过得好不好，因为怕听到答案。她说其实她回来，只是想知道这个家还有没有她的位置。',
      '话还没说完，电话响了。电话那头只有一句：他回来了。镜头切到老宅大门外，一辆车的灯在雨里亮起。',
    ],
  },
  {
    id: 7,
    episode: 7,
    title: '归来的影子',
    summary: '七年前那场事故的另一位当事人出现，所有人的说法开始对不上。',
    date: '2026-09-23',
    duration: '48分钟',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20illustration%20of%20a%20silhouetted%20man%20standing%20at%20the%20end%20of%20a%20long%20hallway%2C%20single%20warm%20light%20overhead%2C%20deep%20crimson%20wall%20panels%2C%20suspenseful%20editorial%20film%20still%2C%20ivory%20highlights%2C%20no%20text%2C%20dramatic%20shadow%20composition&width=800&height=500&seq=plot-ep07&orientation=landscape',
    paragraphs: [
      '来人名叫沈曼，是七年前那场事故中唯一在场的旁人。她的出现让顾老爷子罕见地动了怒。',
      '沈曼带来的不是证据，而是一段录音。录音里有人反复说着一句话：这件事到此为止，谁也不要再提。',
      '林小满终于明白，自己七年前被送走并不是因为做错了什么，而是因为有人需要她不在场。',
    ],
  },
  {
    id: 8,
    episode: 8,
    title: '姐姐的沉默',
    summary: '苏婉承认自己隐瞒了一部分真相，却坚持说那是最好的选择。',
    date: '2026-09-30',
    duration: '46分钟',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20scene%20of%20an%20elegant%20woman%20seated%20by%20a%20tall%20window%20in%20an%20old%20villa%2C%20soft%20rain%20light%2C%20deep%20crimson%20upholstery%2C%20ivory%20walls%2C%20quiet%20emotional%20film%20still%2C%20editorial%20mood%2C%20no%20text&width=800&height=500&seq=plot-ep08&orientation=landscape',
    paragraphs: [
      '苏婉把妹妹叫到书房，第一次没有绕弯子。她说当年那份协议是她签的字，因为她认为那是唯一能保住所有人的办法。',
      '小满问她：那我呢？苏婉沉默了很久，说，我以为你会过得更好。',
      '这一集几乎全部发生在书房里。两个人从争执到疲惫，最后苏婉把一串旧钥匙放在桌上，说阁楼上还有你没看完的东西。',
    ],
  },
  {
    id: 9,
    episode: 9,
    title: '阁楼上的第二封信',
    summary: '另一封从未寄出的信，把顾长川也拉进了七年前的秘密。',
    date: '2026-10-07',
    duration: '47分钟',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20attic%20interior%20with%20dusty%20wooden%20beams%2C%20old%20letters%20and%20a%20single%20warm%20lamp%2C%20deep%20red%20fabric%20draped%20over%20a%20chair%2C%20ivory%20dust%20light%2C%20mysterious%20elegant%20film%20still%2C%20no%20text%2C%20textured%20shadows&width=800&height=500&seq=plot-ep09&orientation=landscape',
    paragraphs: [
      '阁楼的木箱里放着第二封信。信封上写着顾长川的名字，却从来没有被拆开。',
      '信里，母亲解释了当年离开的原因，也提到了一份被藏起来的股权文件。顾长川读到一半就停了，把信折好放回原处。',
      '小满问他为什么不看完。他说，有些答案知道了，就再也回不到从前。',
    ],
  },
  {
    id: 10,
    episode: 10,
    title: '冬夜长谈',
    summary: '顾老爷子病倒，顾家兄妹在医院走廊里第一次真正和解。',
    date: '2026-10-14',
    duration: '48分钟',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20hospital%20corridor%20at%20night%20with%20warm%20amber%20lights%20and%20long%20shadows%2C%20deep%20crimson%20bench%2C%20ivory%20walls%2C%20two%20distant%20figures%2C%20restrained%20emotional%20film%20still%2C%20no%20text%2C%20quiet%20melancholic%20atmosphere&width=800&height=500&seq=plot-ep10&orientation=landscape',
    paragraphs: [
      '顾老爷子在书房晕倒，被送进医院。走廊的灯一整夜都亮着，顾长川和小满坐在长椅上，从沉默聊到天亮。',
      '他承认自己这些年一直在替父亲做决定，也承认自己害怕小满回来会拆散这个家。小满说，家不是靠瞒着才保住的。',
      '清晨，医生说病人已经脱离危险。顾长川起身去买两杯热豆浆，走开几步又回头说了一句：这次别再走了。',
    ],
  },
  {
    id: 11,
    episode: 11,
    title: '把灯留下',
    summary: '真相被摊在桌面上，顾家必须决定如何面对外界的目光。',
    date: '2026-10-21',
    duration: '46分钟',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20cinematic%20living%20room%20at%20dusk%20with%20a%20long%20wooden%20table%2C%20documents%20spread%20out%2C%20warm%20lamp%20glow%20and%20deep%20crimson%20curtains%2C%20ivory%20walls%2C%20tense%20family%20meeting%20film%20still%2C%20no%20text%2C%20refined%20moody%20palette&width=800&height=500&seq=plot-ep11&orientation=landscape',
    paragraphs: [
      '顾家召开了一次没有外人的家庭会议。股权文件、录音和两封信被摆在桌上，所有隐瞒都失去了遮蔽。',
      '苏婉提出卖掉老宅，用这笔钱结束所有纠纷。顾老爷子却第一次开口挽留，他说房子可以卖，灯不能灭。',
      '会议没有结论，但每个人都说出了自己的立场。片尾，小满一个人把客厅的灯一盏一盏打开，直到整座宅子亮起来。',
    ],
  },
  {
    id: 12,
    episode: 12,
    title: '春天来的时候',
    summary: '老宅的门重新打开，小满在院子里种下一棵新的树。',
    date: '2026-10-28',
    duration: '52分钟',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20spring%20courtyard%20scene%20with%20young%20tree%2C%20soft%20warm%20sunlight%2C%20ivory%20stone%20wall%20and%20deep%20crimson%20door%2C%20elegant%20hopeful%20film%20still%2C%20delicate%20blossoms%2C%20no%20text%2C%20refined%20editorial%20composition%20with%20gentle%20light&width=800&height=500&seq=plot-ep12&orientation=landscape',
    paragraphs: [
      '春天来得比往年早。老宅的院门重新打开，顾长川把修好的门牌挂回去，小满在院子中央种下一棵小树。',
      '苏婉带着行李离开，临走前把那条旧围巾留在了椅背上。她说自己需要一段时间，去把没想清楚的事想清楚。',
      '顾老爷子坐在廊下晒太阳，看着院子里的人来来往往。最后一场戏没有台词，只有风穿过新叶的声音，和一句写在门后的字：禁止的爱，也可以被好好放下。',
    ],
  },
];